import { getTimeFromTimeStamp } from '../../../../../../util/time-helpers';

const getValueFromName = (values, name) => {
    return values.find((value) => value.name === name);
};

export const reminderHelpers = {

    setOnDueDate: (setTaskReminder) => {
        setTaskReminder((prevState) => ({
            ...prevState,
            reminder: { id: "0", name: "On End Date" },
        }));
    },

    setRecurring: (setTaskReminder) => {
        setTaskReminder((prevState) => ({
            ...prevState,
            reminder: { id: "1", name: "Recurring" },
        }));
    },

    setOneTime: (setTaskReminder) => {
        setTaskReminder((prevState) => ({
            ...prevState,
            reminder: { id: "2", name: "Before Due Date" },
        }));
    },

    setCustom: (setTaskReminder) => {
        setTaskReminder((prevState) => ({
            ...prevState,
            reminder: { id: "4", name: "Custom" },
        }));
    },

    updateExist: (setTaskReminder, checked) => {
        if (!checked) {
            setTaskReminder(reminderHelpers.emptyReminderObject());
        }
        else {
            setTaskReminder((prevState) => ({
                ...prevState,
                exist: !prevState.exist,
            }));
        }
    },

    handleChange: (change, value, setTaskReminder) => {
        setTaskReminder((prevState) => ({
            ...prevState,
            [change]: value,
        }));
    },

    getReminderDetails: (taskReminder) => {
        if (taskReminder.reminder.id == 0) {
            return {
                reminderOnDueDate: true,
                reminderOneTime: false,
                reminderOneTimeDaysBefore: 0,
                reminderOneTimeTime: getTimeFromTimeStamp(taskReminder.time),
                reminderRecurring: null,
                reminderRecurringTime: null,
            };
        }

        if (taskReminder.reminder.id == 1) {
            return {
                reminderOnDueDate: false,
                reminderOneTime: false,
                reminderOneTimeDaysBefore: 0,
                reminderOneTimeTime: null,
                reminderRecurring: taskReminder.reminderRecurring.name,
                reminderRecurringTime: getTimeFromTimeStamp(taskReminder.time),
                ...(taskReminder.reminderRecurring.name === "Custom" && {
                    reminderRecurringIntervalType:
                        taskReminder.reminderRecurringIntervalType.name,
                    reminderRecurringIntervalValue: taskReminder.days,
                }),
            };
        }

        if (taskReminder.reminder.id == 2 || taskReminder.reminder.id == 3) {
            return {
                reminderOnDueDate: false,
                reminderOneTime: true,
                reminderOneTimeDaysBefore: taskReminder.days,
                reminderOneTimeTime: getTimeFromTimeStamp(taskReminder.time),
                reminderRecurring: null,
                reminderRecurringTime: null,
            };
        }
    },

    emptyReminderObject: () => {
        return {
            exist: false,
            reminder: reminderHelpers.reminderValues[0],
            reminderRecurring: reminderHelpers.reminderRecurringValues[0],
            reminderRecurringIntervalType:
                reminderHelpers.reminderRecurringIntervalTypeValues[0],
            time: new Date().setHours(9, 30),
            days: 2,
            name: ""
        };
    },
    reminderValues: [
        { id: "2", name: "Before Due Date" },
        { id: "3", name: "After Start Date" },
    ],
    reminderRecurringValues: [
        { id: "1", name: "Daily" },
        { id: "2", name: "Weekly" },
        { id: "3", name: "Monthly" },
        { id: "5", name: "Hourly" },
        { id: "6", name: "Custom" },
    ],
    reminderRecurringIntervalTypeValues: [
        { id: "1", name: "Days" },
        { id: "2", name: "Weeks" },
        { id: "3", name: "Months" },
        { id: "4", name: "Years" },
        { id: "5", name: "Business Days" },
    ],
    allReminderValues: [
        { id: "0", name: "On End Date" },
        { id: "1", name: "Recurring" },
        { id: "2", name: "Before Due Date" },
        { id: "3", name: "After Start Date" },
        { id: "4", name: "Custom" },
    ],
    getReminderDetailsFromTask: (task) => {
        const newObject = reminderHelpers.emptyReminderObject();
        newObject.exist = true;
        newObject.name = task.Name;
        newObject.reminder = getValueFromName(
            reminderHelpers.allReminderValues,
            task.Reminder
        );
        newObject.time = new Date(task.ReminderOneTimeTime);
        if (task.Reminder === "Recurring") {
            newObject.reminderRecurring = getValueFromName(
                reminderHelpers.reminderRecurringValues,
                task.ReminderRecurring
            );
            newObject.time = new Date(task.ReminderRecurringTime);
            if (task.ReminderRecurring === "Custom") {
                newObject.reminderRecurringIntervalType = getValueFromName(
                    reminderHelpers.reminderRecurringIntervalTypeValues,
                    task.ReminderRecurringIntervalType
                );
                newObject.days = task.ReminderRecurringIntervalValue;
            }
        } else if (
            task.Reminder === "Before Due Date" ||
            task.Reminder === "After Start Date"
        ) {
            newObject.days = task.ReminderOneTimeDaysBefore;
        } else if (task.Reminder === "Custom") {
            newObject.customreminders = task.CustomReminders;
        }

        return newObject;
    },
};


const isInt = (value) => {
    return (
        !isNaN(value) &&
        parseInt(Number(value)) === value &&
        !isNaN(parseInt(value, 10))
    );
};

export const getValidDaysTaskType = (time, intervals, taskType, setTaskType) => {
 
    let nDays = parseInt(time);
    let checkValidDays = isInt(nDays);
    let validDays = 1;
    let isBusinessDays = false;
    if (checkValidDays) {
        if (intervals === "Days") {
            validDays = nDays * 1;
        } else if (intervals == "Business Days") {
            validDays = nDays * 1;
            isBusinessDays = true;
        } else if (intervals === "Weeks") {
            validDays = nDays * 7;
        } else if (intervals === "Months") {
            validDays = nDays * 30;
        } else if (intervals === "Years") {
            validDays = nDays * 365;
        }
    }
    else{
        validDays = 2;
    }

    setTaskType({
        ...taskType,
        Days: validDays,
        DefaultDurationUnits: time,
        IsBusinessDays: isBusinessDays,
        DefaultDurationInterval: intervals,
    });
};

export const loadDurationFields = (days, IsBusinessDays, taskType, setTaskType) => {
    let durationAmount = days;
    let selectedDurationOption = { id: 1, name: "Days" };
    if (IsBusinessDays) {
        selectedDurationOption = { id: 2, name: "Business Days" };
    } else if (days % 365 === 0) {
        selectedDurationOption = { id: 365, name: "Years" };
        durationAmount = days / 365;
    } else if (days % 30 === 0) {
        selectedDurationOption = { id: 30, name: "Months" };
        durationAmount = days / 30;
    } else if (days % 7 === 0) {
        selectedDurationOption = { id: 7, name: "Weeks" };
        durationAmount = days / 7;
    }

    setTaskType({
        ...taskType,
        DefaultDurationUnits: durationAmount,
        DefaultDurationInterval: selectedDurationOption.name,
    });
};

//#region Custom Reminder Helper Functions

export const customReminderHelpers = {
    reminderValues: [
        { id: "Before Due Date", name: "Before Due Date" },
        { id: "After Start Date", name: "After Start Date" },
    ],
    reminderRecurringIntervalTypeValues: [
        { id: "Days", name: "Day(s)" },
        { id: "Business Days", name: "Business Day(s)" },
        { id: "Weeks", name: "Week(s)" },
        { id: "Months", name: "Month(s)" },
        { id: "Years", name: "Year(s)" },
    ],
};

export const deleteCustomReminder = (removeIdx, customReminders, setCustomReminders) => {
    setCustomReminders(customReminders.filter((_, idx) => removeIdx !== idx));
};
export const addCustomReminder = (customReminders, setCustomReminders) => {
    let newTime = new Date();
    newTime.setHours(9);
    newTime.setMinutes(30);
    let newObject = {
        Id: 0,
        Unit: "1",
        Period: "Days",
        ReminderType: "After Start Date",
        ReminderTime: newTime,
    };
    setCustomReminders([...customReminders, newObject]);
};

export const reminderChangeHandler = (field, newValue, idx, customReminders, setCustomReminders) => {
    const updatedReminders = customReminders.map((cr, index) =>
        idx === index ? { ...cr, [field]: newValue } : cr
    );
    setCustomReminders(updatedReminders);
};

export const addDateZeroes = (value, prepend) => {
    if (value.toString().length == 1) {
        if (prepend) {
            return '0' + value.toString();
        }
        else {
            return value.toString() + '0';
        }
    }
    return value;
}

//#endregion